var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticClass: "pt-0",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [
                        _vm._v(" Migration Instructions & Details ")
                      ]),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      " Now we need some information about your previous provider. Answer as accurately as possible to expedite your request. "
                                    )
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " Don't know everything? No problem! Just tell us what you can, and we will be in touch if we have any questions. "
                                    )
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " In most cases it is ideal to provide us with your primary control panel or account management login. This will usually give us everything we need to complete your migration. You can provide us with your FTP information instead if you are just transferring a website. Use the Additional Instructions field to supply additional login information and/or other instructions for us. "
                                    )
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " More information about migrating to GreenGeeks is available in our "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://www.greengeeks.com/kb/2498/greengeeks-migration-policy/",
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(" Migration Policy ")]
                                    ),
                                    _vm._v(". ")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-form",
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            attrs: {
                                              outlined: "",
                                              label: "Previous Hosting Provider"
                                            },
                                            model: {
                                              value: _vm.previous_provider,
                                              callback: function callback($$v) {
                                                _vm.previous_provider = $$v
                                              },
                                              expression: "previous_provider"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            attrs: {
                                              outlined: "",
                                              label: "Control Panel URL"
                                            },
                                            model: {
                                              value: _vm.cp_url,
                                              callback: function callback($$v) {
                                                _vm.cp_url = $$v
                                              },
                                              expression: "cp_url"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _c("gg-select", {
                                            attrs: {
                                              outlined: "",
                                              label: "Control Panel Type",
                                              items: _vm.cp_items,
                                              "item-text": "name",
                                              "item-value": "value"
                                            },
                                            model: {
                                              value: _vm.cp_type,
                                              callback: function callback($$v) {
                                                _vm.cp_type = $$v
                                              },
                                              expression: "cp_type"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            attrs: {
                                              outlined: "",
                                              label: "FTP Hostname"
                                            },
                                            model: {
                                              value: _vm.hostname,
                                              callback: function callback($$v) {
                                                _vm.hostname = $$v
                                              },
                                              expression: "hostname"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            attrs: {
                                              outlined: "",
                                              label:
                                                "Control Panel/FTP Username"
                                            },
                                            model: {
                                              value: _vm.username,
                                              callback: function callback($$v) {
                                                _vm.username = $$v
                                              },
                                              expression: "username"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "4"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            attrs: {
                                              outlined: "",
                                              label:
                                                "Control Panel/FTP Password"
                                            },
                                            model: {
                                              value: _vm.password,
                                              callback: function callback($$v) {
                                                _vm.password = $$v
                                              },
                                              expression: "password"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "gg-input",
                                            attrs: {
                                              label:
                                                "Additional Instructions or Comments (for example: additional login information, steps to login, etc)",
                                              dense: "",
                                              outlined: ""
                                            },
                                            model: {
                                              value: _vm.notes,
                                              callback: function callback($$v) {
                                                _vm.notes = $$v
                                              },
                                              expression: "notes"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c("gg-error", {
                                        attrs: {
                                          data: this.errors.all()
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-container",
        {
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.setStep(1)
                        }
                      }
                    },
                    [_vm._v(" Back ")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mx-1",
                      attrs: {
                        color: "primary",
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.submit
                      }
                    },
                    [_vm._v(" Submit Migration Request ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }